if (!window.pcsNavigationKeys) {
  window.pcsNavigationKeys = true;
  document.addEventListener('keydown', (event) => {
    if (window.innerWidth < 768) return;
    const navigation = document.getElementById('main-nav');
    if (!navigation?.contains(event.target)) return;
    const topItem = event.target.closest('.navigation__tier-1 > .navigation__item--with-children');
    if (!topItem) return;
    const link = topItem.querySelector(':scope > .navigation__link');
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
      topItem.dispatchEvent(new Event('mouseleave'));
      link.focus();
    } else if (event.target === link && (event.key === 'ArrowDown' || event.key === ' ')) {
      event.preventDefault();
      navigation.querySelectorAll('.navigation__item--show-children').forEach((item) => {
        if (item !== topItem) item.dispatchEvent(new Event('mouseleave'));
      });
      topItem.dispatchEvent(new Event('mouseenter'));
      if (event.key === 'ArrowDown') {
        setTimeout(() => {
          if (document.activeElement === link && link.getAttribute('aria-expanded') === 'true') {
            topItem.querySelector('.navigation__tier-2 a.navigation__link')?.focus();
          }
        }, 300);
      }
    }
  }, true);
  document.addEventListener('focusin', (event) => {
    if (window.innerWidth < 768) return;
    document.querySelectorAll('#main-nav .navigation__tier-1 > .navigation__item--show-children').forEach((item) => {
      if (!item.contains(event.target)) item.dispatchEvent(new Event('mouseleave'));
    });
  });
  document.addEventListener('click', (event) => {
    const drawer = event.target.closest('.mobile-navigation-drawer');
    if (!drawer) return;
    drawer.querySelectorAll('.navigation__item--with-children').forEach((item) => {
      item.querySelector(':scope > .navigation__link')?.setAttribute(
        'aria-expanded', String(item.classList.contains('navigation__item--open'))
      );
    });
  });
}
